<template>
  <v-overlay :value="overlay" opacity="0.7">
    <v-card class="modal-card">
      <v-card-title class="headline">Welcome to ABC!</v-card-title>
      <v-card-text>
        This is a popup modal shown on your first visit.
        <br>
        <a href="https://abc.herbalgram.org/site/SSurvey?ACTION_REQUIRED=URI_ACTION_USER_REQUESTS&SURVEY_ID=3343">Register Today</a>
        <br>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('dismiss')">Dismiss</v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: 'OverlayModal',
  props: ['overlay']
}
</script>

<style scoped>
.modal-card {
  max-width: 600px;
  margin: auto;
  padding: 30px;
}
</style>
